import { render, staticRenderFns } from "./TagNav.vue?vue&type=template&id=80a2faae&scoped=true"
import script from "./TagNav.vue?vue&type=script&lang=js"
export * from "./TagNav.vue?vue&type=script&lang=js"
import style0 from "./TagNav.vue?vue&type=style&index=0&id=80a2faae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80a2faae",
  null
  
)

export default component.exports